import * as Yup from 'yup';

import { Strings } from '@app/constants';

// ----------------Add Testimonial----------------
export const addTestimonialSchema = Yup.object()
  .shape({
    clientId: Yup.string().required(Strings.validation.selectRequired(Strings.field.client)),
    projectName: Yup.string().required(Strings.validation.fieldRequired(Strings.field.projectName)),
    feedback: Yup.string().required(Strings.validation.fieldRequired(Strings.field.feedback)),
    projectLink: Yup.string().required(Strings.validation.fieldRequired(Strings.field.projectLink)),
  })
  .required();
